module.exports = __webpack_public_path__ + "img/default_video.e8b67c78.jpg";